module.exports = __webpack_public_path__ + "img/list_portrait_default_women@3x.ac33a793.png";